<template>
  <el-aside :width="width">
    <div :class="isCollapse ? 'logo--collapse' : 'logo'"></div>

    <el-menu
      :default-active="$route.path"
      :router="true"
      background-color="transparent"
      unique-opened
      text-color="#ffffff"
      active-text-color="#3b6bcf"
      :collapse="isCollapse"
    >
      <el-menu-item index="/record">
        <i class="el-icon-menu"></i>
        <span slot="title">扫码记录</span>
      </el-menu-item>

      <el-menu-item v-if="userInfo['role'] === '超级管理员'" index="/user">
        <i class="el-icon-s-custom"></i>
        <span slot="title">用户管理</span>
      </el-menu-item>

      <el-menu-item index="/wx-staff">
        <i class="el-icon-user"></i>
        <span slot="title">员工管理</span>
      </el-menu-item>

      <el-menu-item index="/wx-user">
        <i class="el-icon-user-solid"></i>
        <span slot="title">学生管理</span>
      </el-menu-item>

    </el-menu>
  </el-aside>
</template>

<script>
import { Aside, Menu, Submenu, MenuItem } from "element-ui";
import { getUserInfo } from "@/utils/auth";
export default {
  name: "Navbar",
  components: {
    [Aside.name]: Aside,
    [Menu.name]: Menu,
    [Submenu.name]: Submenu,
    [MenuItem.name]: MenuItem,
  },
  computed: {
    isCollapse() {
      return this.$store.getters.isCollapse;
    },
    width() {
      return this.isCollapse ? "64px" : "200px";
    },
    userInfo() {
      return getUserInfo()
    }
  },
};
</script>
